<template lang="pug">
  //.mb-2#headerCard(no-body, header-tag="header", footer-tag="footer")
  b-navbar.headerCard.mb-2(variant="dark", type="dark")
    .header-item-box.mx-auto
      b-navbar-nav
        b-nav-item(:to="{name: 'TopPage'}")
          b-icon.mt-1.mr-3(scale=1.4, icon="house")
          span.mt-1.mr-3 クラウド版サポートサイト

        span.mt-2.mr-3 |

        b-nav-item-dropdown.mt-1.mr-3(text="ご契約内容の確認・変更")
          template(v-if="sales_channel !== '1' && neo_contract_status !== false")
            b-dropdown-item(:to="{name: 'NeoNumberChange'}") ユーザー数確認・変更
          b-dropdown-item(v-if="neo_contract_status !== false || chat_contract_status !== false", :to="{name: 'ContractDetails'}") 契約内容確認
          b-dropdown-item(
            v-if="(sales_channel == '0' && (neo_contract_status !== false || chat_contract_status !== false))"
            :to="{ name: 'ApplyPlan' }"
          )
            | プラン変更
          b-dropdown-item(v-if="neo_contract_status !== false || chat_contract_status !== false", :to="{name: 'ContractChanges'}")
            template(v-if="sales_channel !== '1' && has_special_priced_item === false") 変更申し込み／見積書作成
            template(v-else) 変更申し込み
          b-dropdown-item(v-if="neo_contract_status !== false || chat_contract_status !== false", :to="{name: 'OrderHistory'}") 申し込み履歴
          b-dropdown-item(v-if="(sales_channel !== '1' && has_special_priced_item === false && neo_contract_status !== false) || (sales_channel !== '1' && has_special_priced_item === false && chat_contract_status !== false)", :to="{name: 'QuotationList'}") 見積書一覧
          b-dropdown-item(v-if="display_e_invoice_flg === true" href="https://billing.neo.co.jp/", target="_blank") 電子請求システム
            b-icon.ml-1(icon="box-arrow-up-right", scale="0.8")

            //-
              template(v-else)
                b-dropdown-item ご契約をされる場合は、販売店にお問い合わせください。

        //b-nav-item.mt-1(:to="{name: 'LeadToNeoContract'}", right) desknet's NEO

        span.mt-2.mr-3 |

        b-nav-item-dropdown.mt-1.mr-auto(text="お役立ち情報")
          b-dropdown-item(href="https://mk.desknets.com/usefultips", target="_blank") お役立ちサイト
          b-dropdown-item(href="https://www.desknets.com/neo/users/media/", target="_blank") みなとデスクネッツ
            //-
              template(v-else)
                b-dropdown-item ご契約をされる場合は、販売店にお問い合わせください。

        b-nav-item-dropdown.mt-1.mr-3.ml-1.float-right(right, data-testid="dropdown_customer")
          template(slot="button-content")
            span.mr-2 ご登録情報メニュー
            b-icon(icon="gear")
          template(v-if="isLoadingHeader === true")
            loading(:height="30")
          template(v-else)
            b-dropdown-item(:to="{name: 'ShowCustomerInfo'}" data-testid="show_customer_info") ご契約者情報
            b-dropdown-item.ml-3(:to="{name: 'ShowCustomerInfo'}" data-testid="show_customer_info") お客様情報確認
            b-dropdown-item.ml-3(v-if="sales_channel === '0'", :to="{name: 'ChangeCustomerInfo'}") お客様情報変更
            b-dropdown-item.ml-3(v-if="sales_channel === '0'", :to="{name: 'ChangeMail'}") E-mail変更
            b-dropdown-item.ml-3(v-if="sales_channel === '0'", :to="{name: 'ChangePayment'}") ご契約種別・お支払い方法変更
            b-dropdown-item(:to="{name: 'AccountList'}") アカウント管理
            b-dropdown-item.ml-3(:to="{name: 'AccountList'}") ユーザーアカウント登録
            b-dropdown-item.ml-3(:to="{name: 'ChangePassword'}") パスワード変更
            b-dropdown-item(:to="{name: 'ProductManuals'}", target="_blank") 各種製品マニュアル
            b-dropdown-item(href="https://faq.desknets.com/?init=1&kinds=クラウド版サポート", target="_blank") よくあるご質問
            b-dropdown-item(:to="{name: 'ContactInfo'}") お問い合わせ
            b-dropdown-item(data-testid="logout" @click="logout") ログアウト
</template>

<script>
import Api from '@/repositories/api'
const LoginRepository = Api.get('c201Login')
import Loading from '@/components/Loading';

export default {
  name: "HeaderMenu",
  components: {
    Loading
  },
  props: {
    neo_contract_status: { type: [String, Boolean], require: true },
    chat_contract_status: { type: [String, Boolean], require: true },
    isLoadingHeader: { type: Boolean, require: true },
    sales_channel: { type: String, require: true },
    has_special_priced_item: { type: Boolean, required: true },
    display_e_invoice_flg: { type: Boolean, required: true },
  },
  methods: {
    logout() {
      // ログアウト処理
      LoginRepository.logout()
        .catch(() => {
          // エラー回避のためcatchを空で置く
        })
        .finally(() => {
          // 処理結果に関わらず、ログイン画面またはマスタパスワードログイン画面へ遷移する
          this.moveToLoginPage()
        })
    },
  },
  computed: {
    btnStyle: function() {
      return this.$route.meta.currentPage;
    }
  },
}
</script>

<style scoped>
.nav-class {
  color: white;
}
#headerCard {
  margin-top: 0;
  padding: 3px;
  background-color: black
}
.headerCard {
  margin-top: 0;
  padding: 3px;
  background-color: black !important;
}
.nav-item-class {
  background-color: black !important;
}
.btn {
  /* 上 右 下 左 */
  padding: 8px 15px 8px 15px;
  border: none;
}
.card-body {
  padding: 3px;
}
.header-item-box {
  width: 1200px;
}
.active-style {
  color: #e8e8e8;
}
.inactive-style {
  color: #e8e8e8;
}
.img-size {
  height: 23px;
  width: 23px;
}
.name-text {
  font-size: 12px;
  color: white;
  opacity: 0.75;
}
</style>
